function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Paypal",
  transform: "translate(-265.293 -636.441)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_337",
  "data-name": "Rectangle 337",
  width: 39.651,
  height: 27.922,
  rx: 5,
  transform: "translate(265.293 636.441)",
  fill: "#253b80"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_180",
  "data-name": "Path 180",
  d: "M317.185,721.924c-.118.775-.71.775-1.283.775h-.326l.229-1.448a.18.18,0,0,1,.178-.152h.149c.39,0,.758,0,.948.222A.721.721,0,0,1,317.185,721.924Zm-.249-2.024h-2.16a.3.3,0,0,0-.3.253l-.874,5.539a.18.18,0,0,0,.178.208h1.031a.3.3,0,0,0,.3-.254l.236-1.494a.3.3,0,0,1,.3-.254h.684a2.219,2.219,0,0,0,2.459-2.053,1.664,1.664,0,0,0-.276-1.395A2.006,2.006,0,0,0,316.936,719.9Z",
  transform: "translate(-42.371 -73.198)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_181",
  "data-name": "Path 181",
  d: "M356.846,737.477a1.153,1.153,0,0,1-1.167.988.8.8,0,0,1-.857-1.006,1.158,1.158,0,0,1,1.159-1,.873.873,0,0,1,.69.282A.9.9,0,0,1,356.846,737.477Zm1.442-2.013h-1.034a.18.18,0,0,0-.178.152l-.045.289-.072-.1a1.473,1.473,0,0,0-1.222-.434,2.379,2.379,0,0,0-2.31,2.08,1.952,1.952,0,0,0,.385,1.589,1.619,1.619,0,0,0,1.3.526,1.979,1.979,0,0,0,1.432-.592l-.046.287a.18.18,0,0,0,.178.209h.932a.3.3,0,0,0,.3-.254l.559-3.541a.179.179,0,0,0-.178-.208Z",
  transform: "translate(-77.266 -86.763)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_182",
  "data-name": "Path 182",
  d: "M403.661,736.157h-1.039a.3.3,0,0,0-.249.132l-1.434,2.112-.607-2.029a.3.3,0,0,0-.288-.214h-1.022a.18.18,0,0,0-.171.238l1.145,3.36-1.076,1.52a.18.18,0,0,0,.147.284h1.038a.3.3,0,0,0,.247-.129l3.457-4.991a.18.18,0,0,0-.148-.283Z",
  transform: "translate(-117.13 -87.457)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_183",
  "data-name": "Path 183",
  d: "M442.512,721.924c-.118.775-.71.775-1.283.775H440.9l.229-1.448a.18.18,0,0,1,.178-.152h.149c.39,0,.758,0,.948.222A.72.72,0,0,1,442.512,721.924Zm-.249-2.024H440.1a.3.3,0,0,0-.3.253l-.874,5.539a.18.18,0,0,0,.178.208h1.109a.21.21,0,0,0,.207-.177l.248-1.57a.3.3,0,0,1,.3-.254h.684a2.219,2.219,0,0,0,2.459-2.053,1.663,1.663,0,0,0-.276-1.395A2,2,0,0,0,442.263,719.9Z",
  transform: "translate(-152.289 -73.198)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_184",
  "data-name": "Path 184",
  d: "M482.179,737.477a1.153,1.153,0,0,1-1.167.988.8.8,0,0,1-.857-1.006,1.158,1.158,0,0,1,1.159-1,.873.873,0,0,1,.69.282A.891.891,0,0,1,482.179,737.477Zm1.442-2.013h-1.034a.179.179,0,0,0-.178.152l-.046.289-.073-.1a1.472,1.472,0,0,0-1.221-.434,2.378,2.378,0,0,0-2.309,2.08,1.954,1.954,0,0,0,.385,1.589,1.62,1.62,0,0,0,1.3.526,1.98,1.98,0,0,0,1.432-.592l-.046.287a.18.18,0,0,0,.178.209h.932a.3.3,0,0,0,.3-.254l.56-3.541a.18.18,0,0,0-.179-.208Z",
  transform: "translate(-187.191 -86.763)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_185",
  "data-name": "Path 185",
  d: "M522.136,720.054l-.887,5.641a.18.18,0,0,0,.178.208h.891a.3.3,0,0,0,.3-.254l.874-5.539a.18.18,0,0,0-.177-.208h-1A.18.18,0,0,0,522.136,720.054Z",
  transform: "translate(-224.486 -73.2)",
  fill: "#fff"
}));

function SvgIcPaypal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.651,
    height: 27.922,
    viewBox: "0 0 39.651 27.922",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPaypal);
export default ForwardRef;